import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "14",
      cy: "14",
      r: "13.5",
      fill: "#e7e7e7",
      stroke: "#bfc0c7",
      opacity: ".6"
    }, null, -1),
    _createElementVNode("g", { fill: "#000" }, [
      _createElementVNode("path", { d: "M22 13.893A8 8 0 0 1 14.472 22h-.486a8 8 0 0 1-4.78-1.593l-.92 1.04a.334.334 0 0 1-.573-.14l-.986-4.04a.333.333 0 0 1 .36-.407l4.126.5a.333.333 0 0 1 .206.553l-.88.987A6 6 0 0 0 20 13.867a.73.73 0 0 1 .213-.56.67.67 0 0 1 .533-.174l.666.08a.73.73 0 0 1 .414.22.62.62 0 0 1 .173.46m-14.213.774a.73.73 0 0 0 .214-.56 6 6 0 0 1 9.459-5.034l-.88.987a.333.333 0 0 0 .206.553l4.127.5a.334.334 0 0 0 .36-.406l-.987-4.04a.334.334 0 0 0-.573-.14l-.92 1.04A8 8 0 0 0 14 6h-.486A8 8 0 0 0 6 14.107a.62.62 0 0 0 .167.46c.11.117.255.194.413.22l.667.08a.67.67 0 0 0 .54-.2" }),
      _createElementVNode("rect", {
        width: "21.855",
        height: "2.5",
        x: "4.851",
        y: "7.691",
        stroke: "#f1f1f1",
        rx: "1.25",
        transform: "rotate(27.394 4.85 7.691)"
      })
    ], -1)
  ]))]))
}
export default { render: render }